import React from 'react';
import SMTPManager from './components/SMTPManager';
import EmailSender from './components/EmailSender';
import SeedManager from './components/SeedManager';
import BatchLogs from './components/BatchLogs';

function App() {
  return (
    <div>
      <h1 style={{ textAlign: 'center' }}>Mass Mailer UI</h1>
      <SMTPManager />
      <EmailSender />
      <SeedManager />
      <BatchLogs />
    </div>
  );
}


export default App;
